import * as StateLib from "@/Utils/StateLib";
import cx from "classnames";
import { Avatar, Divider, Menu, Text, calculateUserColor } from "@theorgchartdev/storybook";
import React, { Fragment, useRef } from "react";
import { ChangePassModal } from "./ChangePassModal/ChangePassModal";

import { PreferencesModal } from "./PreferencesModal/PreferencesModal";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { appstr } from "@coreapp/utils/appstr";
import { Globals } from "@coreapp/CoreApp/Globals";
import { enumFeaturesList, kAdminUser, kEditionLabels, kROUser, kRWUser } from "@coreapp/constants";
import { getFeatureAccess } from "@/Utils/Misc";

const UserSettingsMenu = ({ divider }) => {
  const nav = useAppNavigate();
  const openCtrlRef = useRef(null);
  let userInfo = StateLib.GetUserInfo();
  let wsMgr = StateLib.GetWSMgr();
  let role = userInfo ? userInfo.GetUserRole() : null;

  if (role == kAdminUser) role = appstr("adminuser");
  else if (role == kRWUser) role = appstr("readwrite");
  else if (role == kROUser) role = appstr("readonly");

  let displayName = wsMgr?.GetUserDisplayName(userInfo);
  let abbreviatedLabel = displayName ? displayName[0].toUpperCase() : "";
  let desiredUserAvatarColor = "orange";
  if (!wsMgr?.fAdminLogin && userInfo)
    desiredUserAvatarColor = calculateUserColor(abbreviatedLabel);

  const [showChangePass, setShowChangePass] = React.useState(false);

  const [showPreferences, setShowPreferences] = React.useState(false);

  const SignOut = () => {
    wsMgr.ChangeDoc("SignOff");
  };

  let userSettings = [
    {
      label: appstr("orgprefs"),
      value: 0,
      icon: "gear",
      disabled: false,
      clickHandler: () => setShowPreferences(!showPreferences),
      dataTestId: "chart-mode-toolbar-preferences"
    },
    {
      label: appstr("Change password"),
      value: 1,
      icon: "key",
      divider: true,
      disabled: false,
      clickHandler: () => setShowChangePass(!showChangePass),
      dataTestId: "chart-mode-toolbar-change-password"
    }
  ];

  if (Globals._uiConfig.fEnableAbout && getFeatureAccess(enumFeaturesList.userDetails)) {
    userSettings.push({
      label: appstr("userdetails (short)"),
      value: 2,
      icon: "circle-info",
      clickHandler: () => {
        nav.navigateDetails("user");
      },
      dataTestId: "chart-mode-toolbar-user-details"
    });
  }

  if (wsMgr && (wsMgr.fAdminLogin || Globals._uiConfig.fEnableSignOut))
    userSettings.push({
      label: appstr("signout"),
      value: 3,
      icon: "arrow-right-from-bracket",
      clickHandler: SignOut,
      dataTestId: "chart-mode-toolbar-sign-out"
    });

  let rawEdition = Globals._accountInfo?.GetOC5Edition();
  let edition = kEditionLabels[rawEdition] ?? rawEdition;
  let orgInfo = wsMgr?.GetOrgInfo();
  let boxCount = orgInfo ? orgInfo.GetBoxCount() : 0;

  const accessMgr = wsMgr?.GetAccessGroupMgr();
  let group = "";
  if (accessMgr) {
    let uGroupID = userInfo?.GetUserGroupID();
    group = accessMgr.GetGroupNameByID(uGroupID);
  }

  let tooltipContent = (
    <div
      className={cx("sidebar-flex-column", "sidebar-flex-gap--small")}
      style={{ padding: "1px" }}
    >
      <div>
        <Text modifier={"medium"} size={"small"} colorModifier={"white"}>
          {role + " - " + group}
        </Text>
      </div>
      <div>
        <Text modifier={"medium"} size={"small"} colorModifier={"white"}>
          {edition + " " + boxCount}
        </Text>
      </div>
      <div>
        <Text modifier={"medium"} size={"small"} colorModifier={"faintgrey"}>
          {displayName}
        </Text>
      </div>
    </div>
  );
  //TODO: user based color choice. Random color if not set.
  let avatarTrigger = (
    <Avatar
      text={abbreviatedLabel}
      isTriggerButton={true}
      color={desiredUserAvatarColor}
      tooltipProps={{
        content: tooltipContent,
        position: "bottom-end",
        referenceOpenCtrlRef: openCtrlRef
      }}
      aria-label={appstr("User preferences menu")}
    />
  );
  return (
    <Fragment>
      <Menu
        openCtrlRef={openCtrlRef}
        trigger={avatarTrigger}
        options={userSettings}
        position={"bottom-end"}
        listWidth={"small"}
        disabled={userInfo == null}
        dataTestId={"user-preference-btn"}
      />
      {divider && (
        <div className={"ocn-toolbar-horizontal-divider"}>
          <Divider vertical={true} />
        </div>
      )}
      {showChangePass && <ChangePassModal show={showChangePass} setShow={setShowChangePass} />}
      {showPreferences && <PreferencesModal show={showPreferences} setShow={setShowPreferences} />}
    </Fragment>
  );
};

export default UserSettingsMenu;
